import { withViewModel } from '@hooks/useViewModel';
import Landing from '~/sections/landing/Landing';
import useLanding from '~/sections/landing/useLanding';

const LandingContainer = withViewModel(Landing, useLanding);

export default LandingContainer;
